import React from "react";
import banner2 from "../../assets/img/banner/2.png";
import banner1 from "../../assets/img/banner/6.jpg";
import banner3 from "../../assets/img/banner/3.svg";
import banner4 from "../../assets/img/banner/5.svg";
import bannerVDO from "../../assets/img/banner/7.mp4";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

function Banner() {
  return (
    <>
      <div className="banner-area bg-relative banner-area-1 pd-bottom-100 bg-cover">
        <video autoPlay muted loop className="video-background">
          <source src={bannerVDO} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <img
          className="animate-img-1 top_image_bounce"
          src={banner2}
          alt="img"
        />
        <img
          className="animate-img-2 left_image_bounce"
          src={banner4}
          alt="img"
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="banner-inner pe-xl-5 ps-2">
                <h6
                  className="subtitle wow animated fadeInLeft"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.3s"
                >
                  DESIGNING FOR THE FUTURE
                </h6>
                <h2
                  className="title wow animated fadeInLeft"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.4s"
                >
                  Making The <span>Digital</span> World Work For <br />
                  You
                </h2>
                <p
                  className="content pe-xl-5 wow animated fadeInLeft"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.5s"
                >
                  And In Order To Make A Business, Brand Advertising And
                  Marketing Plays An Important Role. Similarly, In Making
                  Cultivation Business Are Necessary.
                </p>
                <Link to={"/aboutUs"}>
                  <a
                    className="btn btn-border-base wow animated fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.6s"
                  >
                    Discover More <FaPlus />
                  </a>
                </Link>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5 col-md-8 offset-xl-2 offset-lg-1">
              <div
                className="banner-thumb mt-5 mt-lg-0 ms-4 ms-lg-0 wow animated fadeInRight"
                data-wow-duration="1.5s"
                data-wow-delay="0.3s"
              >
                <img
                  className="banner-animate-img banner-animate-img-1 top_image_bounce"
                  src={banner2}
                  alt="img"
                />
                <img
                  className="banner-animate-img banner-animate-img-2"
                  src={banner3}
                  alt="img"
                />
                <img
                  className="banner-animate-img banner-animate-img-3 left_image_bounce"
                  src={banner3}
                  alt="img"
                />
                <img className="main-img" src={banner1} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
